// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"501":"39d09b9e","656":"fde43b20","898":"e8712da0","956":"bbe4e851"}[chunkId] + ".chunk.css";
};